export const getTwoFactorAuthenticationToastId = (mfaRequirement, id) => `workspace-enforcement-change-${mfaRequirement}-${id}`;
